import BrandMark from "@/components/BrandMark";
import { fmtDateTime } from "@/lib/dates";
import { Wrench } from "lucide-react";

/**
 * Shown to customer/advocate visitors — logged in or not — while an admin-declared maintenance
 * window is active. `Protected` in App.js renders this instead of the normal portal for any
 * non-admin role; admin is never shown it. See backend/CLAUDE.md "Disaster recovery".
 */
export default function MaintenancePage({ note, endAt }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#080C16] text-[#F9F8F6] px-6 text-center gap-4" data-testid="maintenance-page">
      <BrandMark />
      <Wrench className="w-8 h-8 text-[#CBA96C]" strokeWidth={1.5} />
      <h1 className="font-serif-display text-2xl md:text-3xl">Down for scheduled maintenance</h1>
      <p className="text-sm text-[#A0AABF] max-w-md">
        {note || "We're making a change behind the scenes. Please check back shortly."}
      </p>
      {endAt && (
        <p className="text-xs text-[#6B7280]">Expected back by {fmtDateTime(endAt)}</p>
      )}
    </div>
  );
}
